import { render, staticRenderFns } from "./DiscountComponent.vue?vue&type=template&id=f7d9e7a8"
import script from "./DiscountComponent.vue?vue&type=script&lang=js"
export * from "./DiscountComponent.vue?vue&type=script&lang=js"
import style0 from "./DiscountComponent.vue?vue&type=style&index=0&id=f7d9e7a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports